// Run `fn` once the page has finished loading and the browser is idle, so
// third-party SDK downloads never compete with first render / LCP.
// `timeout` caps how long idle-waiting may delay the callback.
export function whenIdle(fn: () => void, timeout = 3000): void {
  let done = false;
  const go = () => {
    if (done) return;
    done = true;
    fn();
  };
  const schedule = () => {
    const w = window as Window & {
      requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
    };
    if (typeof w.requestIdleCallback === "function") {
      w.requestIdleCallback(go, { timeout });
    } else {
      setTimeout(go, 1);
    }
  };
  if (document.readyState === "complete") schedule();
  else window.addEventListener("load", schedule, { once: true });
}
